import React, { ComponentType } from "react";
import { Location, NavigateFunction, useLocation, useNavigate, useParams } from "react-router-dom";

import type { ILazyPage } from "../../common/helpers/lazyPage";

export interface IRouterProps {
    navigate: NavigateFunction,
    location: Location,
    match: { params: Record<string, string | undefined> },
}

// v6 dropped withRouter. This is the replacement React Router's own migration guide
// suggests: the same props, injected from hooks, with navigate in place of history.
export const withRouter = <P extends object>(Component: ComponentType<P>) => {
    const WithRouter = (props: Omit<P, "navigate" | "location" | "match"> & { children?: React.ReactNode }) => {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();
        return <Component {...(props as P)} navigate={navigate} location={location} match={{ params }} />;
    };
    WithRouter.displayName = `withRouter(${Component.displayName || Component.name || "Component"})`;
    // A lazyPage a moduleId-t es a preload-ot statikus mezokent teszi a komponensre, es
    // a preloadRoutes ezeket keresi. A connect() es az injectIntl atemeli az ismeretlen
    // statikusokat, ez a shim viszont nem tette - igy a becsomagolt oldalak a szerveren
    // sosem toltodtek be, es ures torzs ment ki.
    const lazy = Component as Partial<ILazyPage>;
    if (typeof lazy.preload === "function") {
        (WithRouter as Partial<ILazyPage>).preload = lazy.preload;
        (WithRouter as Partial<ILazyPage>).moduleId = lazy.moduleId;
    }
    return WithRouter;
};

export default withRouter;
